// Which sequence is selected after the operator clicks one. Every click site only
// ever selected, so once a sequence was chosen there was no way back to "none":
// the list, the prompt panel and the conditions panel all key off the selection,
// and a job that should run without a sequence could not be set up. Clicking the
// selected sequence again is the one gesture that needs no new control, which is
// what the simple editor is held to.
export function nextSequenceSelection(currentId, clickedId) {
  const same =
    currentId !== null &&
    currentId !== undefined &&
    String(currentId) === String(clickedId);
  return same ? null : clickedId;
}

// The sequence a run picked from the history ran, so the steps and conditions beside it
// are the ones it used; the selection had stayed on whatever was chosen before
// (Yeskendir, 2026-09-29). A direct prompt, or a sequence deleted since, changes nothing.
export function selectionForJob(
  job,
  sequences,
  currentSequenceId,
  currentStepId,
) {
  const sequence = (sequences || []).find(
    item => job?.sequenceId && String(item.id) === String(job.sequenceId),
  );
  if (!sequence) return {};
  const same = String(sequence.id) === String(currentSequenceId);
  return {
    selectedSequenceId: sequence.id,
    selectedStepId: same ? currentStepId : (sequence.steps?.[0]?.id ?? null),
  };
}
